$(document).ready(function() {
  if ($(".panel-body").length && $(".product_info_instruction_container").length) {
    // $(".product_info_instruction_container").insertAfter(".panel-body");
  }
});

/*
 * Measurement videos are launched from inside the product/custom-size modal.
 * Move the Fancybox root to <body> and give it an isolated top layer so the
 * video stays above both the product page and the Showroom product popup.
 */
(function($) {
  var measurementTriggers = [
    '.newclasselgrid',
    '.videoorimagebuts',
    '.videoorimagewaist',
    '.videoorimagehips',
    '.videoorimagehollow',
    '.videoorimagebutt',
    '.videoorimageoptional'
  ].join(',');

  $(document)
    .off('click.csMeasurementVideoLayer', measurementTriggers)
    .on('click.csMeasurementVideoLayer', measurementTriggers, function() {
      window.setTimeout(function() {
        // The measurement guide uses its own video player rather than Fancybox.
        // It is created synchronously by size-chart.liquid, so promote both of
        // its body-level nodes after that click handler has completed.
        var $videoBox = $('body > .mainvideobox').last();
        var $videoBackdrop = $('body > .videoElementdiv').last();
        if ($videoBox.length) {
          $videoBox.addClass('cs-measurement-video-player');
          $videoBackdrop.addClass('cs-measurement-video-backdrop');
        }

        var $fancybox = $('.fancybox-container').last();
        if ($fancybox.length) {
          if (!$fancybox.parent().is('body')) {
            $fancybox.appendTo(document.body);
          }
          $fancybox.addClass('cs-measurement-video-layer');
        }
      }, 0);
    });
})(jQuery);
$(document).ready(function() {
    

    // 向右滚动
    $('.thumbs-wrap-mb_outside_right').on('click', function() {
      // 获取静态图像的宽度
    var imageWidth = $('.thumbs-wrap.thumbs-wrap-mb .static-images').outerWidth();
        $('.thumbs-wrap, .thumbs-wrap-mb').animate({
            scrollLeft: '+=' + imageWidth 
        }, 0); 
    });

    // 向左滚动
    $('.thumbs-wrap-mb_outside_left').on('click', function() {
      // 获取静态图像的宽度
    var imageWidth = $('.thumbs-wrap.thumbs-wrap-mb .static-images').outerWidth();
        $('.thumbs-wrap, .thumbs-wrap-mb').animate({
            scrollLeft: '-=' + imageWidth // 向左滚动一个图像的宽度
        }, 0); 
    });
});

$(document).ready(function() {
  $('input[type="text"]').on('click', function() {
    var $parent1 = $(this).parent();
    var errorDisplayed1 = $parent1.data("errorDisplayed1") || false;
    $parent1.data("errorDisplayed1", false);
    if ($(this).hasClass('ced-input-bust') && !errorDisplayed1) {
        var errorDiv1 = $("<div>").text("The fullest part of the bust. Wear the bra you will be wearing with the dress, and pull the tape across.").addClass("errortext1");

        if ($(window).width() > 768) {
            $(".errortext1").remove();
            $parent1.after(errorDiv1);
        } else {
          // 仅移除其他的 .errortext1 元素，不移除当前的
          $(".errortext1").not($parent1.next(".errortext1")).remove();
          $(".videoimgbox").not($parent1.next(".videoimgbox")).remove();
            // 创建包含指定结构的新的 <div> 元素
          var newDiv = $('<div>', { class: 'videoimgbox' }).append(
              $('<div>', { class: 'videoorimagebuts' }),
          );
  
          // 将新的 <div> 元素插入到 .ced-parameter 元素之后，作为其兄弟元素
          $('.ced-parameter').after(newDiv);
          $('.ced-parameter').after(errorDiv1);
          $(document).on('click', '.videoorimagebuts', function() {
              // Simulate click on .newclasselgrid0
              $('.newclasselgrid0').trigger('click');
          });
        }

        $parent1.data("errorDisplayed1", true);
    }
    if ($(this).hasClass('ced-input-waist') && !errorDisplayed1) {
        var errorDiv1 = $("<div>").text("Pull tape across the narrowest part and keep tape slightly loose to allow for breathing room. If you have a big belly, please give us measurements of your belly in the note too.").addClass("errortext1");
      
        if ($(window).width() > 768) {
            $(".errortext1").remove();
            $parent1.after(errorDiv1);
        } else {
          // 仅移除其他的 .errortext1 元素，不移除当前的
          $(".errortext1").not($parent1.next(".errortext1")).remove();
          $(".videoimgbox").not($parent1.next(".videoimgbox")).remove();
            // 创建包含指定结构的新的 <div> 元素
          var newDiv = $('<div>', { class: 'videoimgbox' }).append(
              $('<div>', { class: 'videoorimagewaist' }),
          );
  
          // 将新的 <div> 元素插入到 .ced-parameter 元素之后，作为其兄弟元素
          $('.ced-parameter').after(newDiv);
          $('.ced-parameter').after(errorDiv1);
          $(document).on('click', '.videoorimagewaist', function() {
              // Simulate click on .newclasselgrid0
              $('.newclasselgrid1').trigger('click');
          });
        }

        $parent1.data("errorDisplayed1", true);
    }
    if ($(this).hasClass('ced-input-hips') && !errorDisplayed1) {
        var errorDiv1 = $("<div>").text("Stand straight and pull tape across the widest part of the hips and rear.").addClass("errortext1");
        if ($(window).width() > 768) {
            $(".errortext1").remove();
            $parent1.after(errorDiv1);
        } else {
          // 仅移除其他的 .errortext1 元素，不移除当前的
          $(".errortext1").not($parent1.next(".errortext1")).remove();
          $(".videoimgbox").not($parent1.next(".videoimgbox")).remove();
            // 创建包含指定结构的新的 <div> 元素
          var newDiv = $('<div>', { class: 'videoimgbox' }).append(
              $('<div>', { class: 'videoorimagehips' }),
          );
  
          // 将新的 <div> 元素插入到 .ced-parameter 元素之后，作为其兄弟元素
          $('.ced-parameter').after(newDiv);
          $('.ced-parameter').after(errorDiv1);
          $(document).on('click', '.videoorimagehips', function() {
              // Simulate click on .newclasselgrid0
              $('.newclasselgrid2').trigger('click');
          });
        }

        $parent1.data("errorDisplayed1", true);
    }
    if ($(this).hasClass('ced-input-butt') && !errorDisplayed1) {
        var errorDiv1 = $("<div>").text("This measurement is necessary if your butt is bigger than your hips, otherwise it's not necessary.").addClass("errortext1");
        if ($(window).width() > 768) {
            $(".errortext1").remove();
            $parent1.after(errorDiv1);
        } else {
          // 仅移除其他的 .errortext1 元素，不移除当前的
          $(".errortext1").not($parent1.next(".errortext1")).remove();
          $(".videoimgbox").not($parent1.next(".videoimgbox")).remove();
            // 创建包含指定结构的新的 <div> 元素
          var newDiv = $('<div>', { class: 'videoimgbox' }).append(
              $('<div>', { class: 'videoorimagebutt' }),
          );
  
          // 将新的 <div> 元素插入到 .ced-parameter 元素之后，作为其兄弟元素
          $('.ced-parameter').after(newDiv);
          $('.ced-parameter').after(errorDiv1);
        }

        $parent1.data("errorDisplayed1", true);
    }
    if ($(this).hasClass('ced-input-hollow') && !errorDisplayed1) {
        var errorDiv1 = $("<div>").text("Stand straight with bare feet together and measure from the center of the collarbone to the floor.").addClass("errortext1");
        if ($(window).width() > 768) {
            $(".errortext1").remove();
            $parent1.after(errorDiv1);
        } else {
          // 仅移除其他的 .errortext1 元素，不移除当前的
            $(".errortext1").not($parent1.next(".errortext1")).remove();
            $(".videoimgbox").not($parent1.next(".videoimgbox")).remove();
              // 创建包含指定结构的新的 <div> 元素
            var newDiv = $('<div>', { class: 'videoimgbox' }).append(
                $('<div>', { class: 'videoorimagehollow' }),
            );
            // 将新的 <div> 元素插入到 .ced-parameter 元素之后，作为其兄弟元素
            $('.ced-parameter').after(newDiv);
            $('.ced-parameter').after(errorDiv1);
            $(document).on('click', '.videoorimagehollow', function() {
              // Simulate click on .newclasselgrid0
              $('.newclasselgrid3').trigger('click');
          });
          
        }

        $parent1.data("errorDisplayed1", true);
    }
    if ($(this).hasClass('ced-input-height') && !errorDisplayed1) {
        var errorDiv1 = $("<div>").text("Stand straight with bare feet together and measure from the top of the head to the floor.").addClass("errortext1");
        if ($(window).width() > 768) {
            $(".errortext1").remove();
            $parent1.after(errorDiv1);
        } else {
            // 仅移除其他的 .errortext1 元素，不移除当前的
            $(".errortext1").not($parent1.next(".errortext1")).remove();
            $(".videoimgbox").not($parent1.next(".videoimgbox")).remove();
          
            $('.ced-parameter').after(errorDiv1);
        }
        $parent1.data("errorDisplayed1", true);
    }
    
    if ($(this).hasClass('ced-input-optional') && !errorDisplayed1) {
        var errorDiv1 = $("<div>").text("If you have big belly, this measurement is necessary.").addClass("errortext1");
        if ($(window).width() > 768) {
            $(".errortext1").remove();
            $parent1.after(errorDiv1);
        } else {
            // 仅移除其他的 .errortext1 元素，不移除当前的
            $(".errortext1").not($parent1.next(".errortext1")).remove();
            $(".videoimgbox").not($parent1.next(".videoimgbox")).remove();
              // 创建包含指定结构的新的 <div> 元素
            var newDiv = $('<div>', { class: 'videoimgbox' }).append(
                $('<div>', { class: 'videoorimageoptional' }),
            );
            // 将新的 <div> 元素插入到 .ced-parameter 元素之后，作为其兄弟元素
            $('.ced-parameter').after(newDiv);
            $('.ced-parameter').after(errorDiv1);
        }
        $parent1.data("errorDisplayed1", true);
    }
});





  
// 注册文本框失去焦点事件处理程序
$("input[type='text']").blur(function() {
    var min = parseFloat($(this).attr("min"));
    var max = parseFloat($(this).attr("max"));
    var value = parseFloat($(this).val());
    var $parent = $(this).parent();
    var errorDisplayed = $parent.data("errorDisplayed") || false;

    // Remove the current error message and reset the flag
    
    $parent.next(".errortext1").remove();
    $parent.data("errorDisplayed1", false);
    $parent.next(".errortext").remove();
    $parent.data("errorDisplayed", false);
    if (isNaN(value) || value < min) {
        $(this).val("");
      var errorDiv; // Declare errorDiv outside the conditions to avoid redeclaration

// For Bust Input Field

      if ($(this).hasClass('girls_size_bust')) {
        errorDiv = $("<div>").text("The minimum Bust measurement for girls styles is 46.99 cm (18.5 inches).").addClass("errortext");
      } else if ($(this).hasClass('ced-input-bust')) {
       errorDiv = $("<div>").text("The minimum Bust measurement for all adult styles is 68 cm (27 inches).").addClass("errortext");
      }


 if ($(this).hasClass('girls_size_waist')) {
        errorDiv = $("<div>").text("The minimum Waist measurement for girls styles is  46 cm (18.5 inches)").addClass("errortext");
      } else if ($(this).hasClass('ced-input-waist')) {
       errorDiv = $("<div>").text("The minimum Waist measurement for all adult styles is 55 cm (22 inches).").addClass("errortext");
      }


 if ($(this).hasClass('girls_size_hips')) {
        errorDiv = $("<div>").text("The minimum Hips measurement for girls styles is 46 cm (18.5 inches).").addClass("errortext");
      } else if ($(this).hasClass('ced-input-hips')) {
       errorDiv = $("<div>").text("The minimum Hips measurement for all adult styles is 76 cm (30 inches).").addClass("errortext");
      }

 if ($(this).hasClass('girls_size_hollow')) {
        errorDiv = $("<div>").text("The minimum hollow measurement for girls styles is 53 cm (21 inches).").addClass("errortext");
      } else if ($(this).hasClass('ced-input-hollow')) {
        errorDiv = $("<div>").text("The minimum hollow measurement for all adult styles is 78 cm (31 inches).").addClass("errortext");
      }

      if ($(this).hasClass('girls_size_height')) {
        errorDiv = $("<div>").text("The minimum Height measurement for girls styles is 83 cm (33 inches).").addClass("errortext");
      } else if ($(this).hasClass('ced-input-height')) {
         errorDiv = $("<div>").text("The minimum Height measurement for all adult styles is 137 cm (54 inches).").addClass("errortext");
      }
      
        // if ($(this).hasClass('ced-input-bust')) {
        //     // errorDiv = $("<div>").text("The minimum Bust measurement for all adult styles is 68 cm (27 inches).").addClass("errortext");
        // } else if ($(this).hasClass('ced-input-waist')) {
        //     // errorDiv = $("<div>").text("The minimum Waist measurement for all adult styles is 55 cm (22 inches).").addClass("errortext");
        // } else if ($(this).hasClass('ced-input-hips')) {
        //     errorDiv = $("<div>").text("The minimum Hips measurement for all adult styles is 76 cm (30 inches).").addClass("errortext");
        // } else if ($(this).hasClass('ced-input-hollow')) {
        //     errorDiv = $("<div>").text("The minimum hollow measurement for all adult styles is 78 cm (31 inches).").addClass("errortext");
        // } else if ($(this).hasClass('ced-input-height')) {
        //     errorDiv = $("<div>").text("The minimum Height measurement for all adult styles is 137 cm (54 inches).").addClass("errortext");
        // }
        $parent.after(errorDiv);
        $parent.data("errorDisplayed", true);
    } else if (value > max) {
        $(this).val("");
        var errorDiv;


           if ($(this).hasClass('girls_size_bust')) {
        errorDiv = $("<div>").text("The minimum Bust measurement for girls styles is 46.99 cm (18.5 inches).").addClass("errortext");
      } else if ($(this).hasClass('ced-input-bust')) {
       errorDiv = $("<div>").text("The maximum Bust measurement for all adult styles is 171 cm (67 inches).").addClass("errortext");
      }


 if ($(this).hasClass('girls_size_waist')) {
        errorDiv = $("<div>").text("The minimum Waist measurement for girls styles is  46 cm (18.5 inches)").addClass("errortext");
      } else if ($(this).hasClass('ced-input-waist')) {
       errorDiv = $("<div>").text("The maximum Waist measurement for all adult styles is 178 cm (70 inches).").addClass("errortext");
      }


 if ($(this).hasClass('girls_size_hips')) {
         errorDiv = $("<div>").text("The minimum Hips measurement for girls styles is 46 cm (18.5 inches).").addClass("errortext");
      } else if ($(this).hasClass('ced-input-hips')) {
       errorDiv = $("<div>").text("The maximum Hips measurement for all adult styles is 190 cm (74.5 inches).").addClass("errortext");
      }

 if ($(this).hasClass('girls_size_hollow')) {
          errorDiv = $("<div>").text("The minimum hollow measurement for girls styles is 53 cm (21 inches).").addClass("errortext");
      } else if ($(this).hasClass('ced-input-hollow')) {
errorDiv = $("<div>").text("The maximum Hollow to Floor measurement for all adult styles is 229 cm (90 inches).").addClass("errortext");
      }

      if ($(this).hasClass('girls_size_height')) {
        errorDiv = $("<div>").text("The minimum Height measurement for girls  styles is 83 cm (33 inches).").addClass("errortext");
      } else if ($(this).hasClass('ced-input-height')) {
        errorDiv = $("<div>").text("The maximum Height measurement for all adult styles is 254 cm (100 inches).").addClass("errortext");
      }
      
        // if ($(this).hasClass('ced-input-bust')) {
        //     errorDiv = $("<div>").text("The maximum Bust measurement for all adult styles is 171 cm (67 inches).").addClass("errortext");
        // } else if ($(this).hasClass('ced-input-waist')) {
        //     errorDiv = $("<div>").text("The maximum Waist measurement for all adult styles is 178 cm (70 inches).").addClass("errortext");
        // } else if ($(this).hasClass('ced-input-hips')) {
        //     errorDiv = $("<div>").text("The maximum Hips measurement for all adult styles is 190 cm (74.5 inches).").addClass("errortext");
        // } else if ($(this).hasClass('ced-input-hollow')) {
        //     errorDiv = $("<div>").text("The maximum Hollow to Floor measurement for all adult styles is 229 cm (90 inches).").addClass("errortext");
        // } else if ($(this).hasClass('ced-input-height')) {
        //     errorDiv = $("<div>").text("The maximum Height measurement for all adult styles is 254 cm (100 inches).").addClass("errortext");
        // }
        $parent.after(errorDiv);
        $parent.data("errorDisplayed", true);
    } else {
        $parent.data("errorDisplayed", false);
    }
});

});

// $(document).ready(function() {
//     $(".form-unit").click(function() {
//         var text = $(this).text().trim();
//         if (text === "CM") {
//             $(".ced-input-bust").attr({
//                 "min": "68",
//                 "max": "171",
//                 "placeholder": "68 - 171"
//             });
//             $(".ced-input-waist").attr({
//                   "min": "55",
//                   "max": "178",
//                   "placeholder": "55 - 178"
//               });
//             $(".ced-input-hips").attr({
//                   "min": "76",
//                   "max": "190",
//                   "placeholder": "76 - 190"
//               });
//             $(".ced-input-butt").attr({
//                   "min": "68",
//                   "max": "181",
//                   "placeholder": "68 - 181"
//               });
//             $(".ced-input-hollow").attr({
//                   "min": "78",
//                   "max": "229",
//                   "placeholder": "78 - 229"
//               });
//             $(".ced-input-height").attr({
//                   "min": "137",
//                   "max": "254",
//                   "placeholder": "137 - 254"
//               });
//             $(".ced-input-optional").attr({
//                   "min": "58",
//                   "max": "180",
//                   "placeholder": "58 - 180"
//               });
//         }else{
//           $(".ced-input-bust").attr({
//                 "min": "22",
//                 "max": "67",
//                 "placeholder": "22 - 67"
//             });
//           $(".ced-input-waist").attr({
//                   "min": "22",
//                   "max": "70",
//                   "placeholder": "22 - 70"
//               });
//             $(".ced-input-hips").attr({
//                   "min": "30",
//                   "max": "74.5",
//                   "placeholder": "30 - 74.5"
//               });
//             $(".ced-input-butt").attr({
//                   "min": "22",
//                   "max": "68",
//                   "placeholder": "22 - 77"
//               });
//             $(".ced-input-hollow").attr({
//                   "min": "31",
//                   "max": "90",
//                   "placeholder": "31 - 90"
//               });
//             $(".ced-input-height").attr({
//                   "min": "54",
//                   "max": "100",
//                   "placeholder": "54 - 100"
//               });
//             $(".ced-input-optional").attr({
//                   "min": "23",
//                   "max": "71",
//                   "placeholder": "23 - 71"
//               });
//         }
//     });
// });
$(document).ready(function() {
    $(".form-unit").click(function() {
        var text = $(this).text().trim();
     
        if (text === "CM") { 
         if ($(".ced-input-bust").hasClass('girls_size_bust')) {
    $(".ced-input-bust.girls_size_bust").attr({
        "min": "46.99",
        "max": "87",
        "placeholder": "46.99 - 87"
    });
  } else {
      $(".ced-input-bust").attr({
          "min": "68",
          "max": "171",
          "placeholder": "68 - 171"
      });
  }

  if ($(".ced-input-waist").hasClass('girls_size_waist')) { 
      $(".ced-input-waist.girls_size_waist").attr({
          "min": "46",
          "max": "82",
          "placeholder": "46 - 82"
      });
  } else {
      $(".ced-input-waist").attr({
          "min": "55",
          "max": "178",
          "placeholder": "55 - 178"
      });
  }
 
          
   if ($(".ced-input-hips").hasClass('girls_size_hips')) {  
    $(".girls_size_hips").attr({
                "min": "46",
                "max": "96",
                "placeholder": "46 - 96"
              });
  } else {
      $(".ced-input-hips").attr({
                    "min": "76",
                    "max": "190",
                    "placeholder": "76 - 190"
                });
  }       
           
  if ($(".ced-input-height").hasClass('girls_size_height')) {  
    $(".girls_size_height").attr({
                "min": "83",
                "max": "171",
                "placeholder": "83 - 171"
              });
  } else {
       $(".ced-input-height").attr({
                    "min": "137",
                    "max": "254",
                    "placeholder": "137 - 254"
                });
  }            
           
if ($(".ced-input-hollow").hasClass('girls_size_hollow')) { 
   $(".girls_size_hollow").attr({
                "min": "53",
                "max": "133",
                "placeholder": "53 - 133"
            });
      } else {
          $(".ced-input-hollow").attr({
                    "min": "78",
                    "max": "229",
                    "placeholder": "78 - 229"
                });
          }         
          
            $(".ced-input-butt").attr({
                  "min": "68",
                  "max": "181",
                  "placeholder": "68 - 181"
              });
          
            $(".ced-input-optional").attr({
                  "min": "58",
                  "max": "180",
                  "placeholder": "58 - 180"
              });

           $(".girls_size").attr({
                "min": "46.99",
                "max": "87",
                "placeholder": "46.99 - 87"
            });
        
        }else{


          if ($(".ced-input-bust").hasClass('girls_size_bust')) {
          $(".ced-input-bust.girls_size_bust").attr({
              "min": "18.5",
              "max": "34",
              "placeholder": "18.5 - 34"
          });
          } else {
               $(".ced-input-bust").attr({
                          "min": "22",
                          "max": "67",
                          "placeholder": "22 - 67"
                        });
            }
        
                  if ($(".ced-input-waist").hasClass('girls_size_waist')) {  
            $(".ced-input-waist.girls_size_waist").attr({
                "min": "18.5",
                "max": "32",
                "placeholder": "18.5 - 32"
            });
        } else {
            $(".ced-input-waist").attr({
                          "min": "22",
                          "max": "70",
                          "placeholder": "22 - 70"
                      });
        }
 
         

           if ($(".ced-input-hips").hasClass('girls_size_hips')) {  
            $(".girls_size_hips").attr({
                        "min": "18.5",
                        "max": "37.5",
                        "placeholder": "18.5 - 37.5"
                    });
        } else {
              $(".ced-input-hips").attr({
                          "min": "30",
                          "max": "74.5",
                          "placeholder": "30 - 74.5"
                      });
        }      
          
            $(".ced-input-butt").attr({
                  "min": "22",
                  "max": "68",
                  "placeholder": "22 - 77"
              });

             if ($(".ced-input-hollow").hasClass('girls_size_hollow')) {  
           $(".girls_size_hollow").attr({
                        "min": "53",
                        "max": "133",
                        "placeholder": "21 - 52"
                          });
              } else {
                         $(".ced-input-hollow").attr({
                                "min": "31",
                                "max": "90",
                        "placeholder": "31 - 90"
                    });
          }   
          
      

             if ($(".ced-input-height").hasClass('girls_size_height')) {  
          $(".girls_size_height").attr({
                "min": "83",
                "max": "171",
                "placeholder": "33 - 67"
            });
        } else {
           $(".ced-input-height").attr({
                        "min": "54",
                        "max": "100",
                        "placeholder": "54 - 100"
                    });
      }   
                

            $(".ced-input-optional").attr({
                  "min": "23",
                  "max": "71",
                  "placeholder": "23 - 71"
              });
        }
    });
});
